import { render, staticRenderFns } from "./DocumentsChangeSummaryDialog.vue?vue&type=template&id=5289f08d"
import script from "./DocumentsChangeSummaryDialog.vue?vue&type=script&lang=ts"
export * from "./DocumentsChangeSummaryDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports